import React from 'react';
import TimelineEvents from "../../../../../components/timeline-events/timeline-events.jsx";
import {buildCompleteTimelineItems} from "../helpers/timeline-items.jsx";
import TimelineTitle from "../helpers/timeline-title.jsx";

const TimelineContent = ({ data, boName, printOptions, boId, individualList }) => {
    const timelineItems = buildCompleteTimelineItems(data, printOptions, individualList);

    return (
        <>
            <TimelineTitle data={data} boName={boName} boId={boId}/>
            <TimelineEvents items={timelineItems} title={false} data={data}/>
        </>
    );
};

export default TimelineContent;